export enum ScanStatus {
    None = 'none',
    Clean = 'clean',
    Infected = 'infected',
    Failed = 'failed',
    InProgress = 'inProgress'
}
